import {AppResourceSearch, ApiFilter} from '@sellers-shield-home-protection/ss-core-js';
export async function freePackage(agent, state) {

    if (!!agent.brokerUuid) {

        const appResourceSearch = new AppResourceSearch('broker');

        await appResourceSearch.setSearchData({
            filter: new ApiFilter({
                params: {
                    uuid: agent.brokerUuid,
                },
            }),
        }, false);

        await appResourceSearch.search();
        let broker = appResourceSearch.appResourceCollection.getFirst();
        let freePack = Object.assign({}, JSON.parse(broker?.freePackage) || []);

        let approvedStates = JSON.parse(broker?.freePackage).states;
        if (approvedStates && state in approvedStates) {
            return {
                'hslp': {
                    legalProtectionAmount: freePack?.hslp?.legalProtectionAmount ?? freePack?.hslp?.legal_protection_amount,
                    yearsLegalProtection: freePack?.hslp?.yearsLegalProtection ?? freePack?.hslp?.years_legal_protection,
                    tier: freePack.hslp.tier,
                    solutionPurchasedId: freePack?.hslp?.solutionPurchasedId ?? freePack?.hslp?.solution_purchased_id,
                    paymentFromId: freePack?.hslp?.paymentFromId ?? freePack?.hslp?.payment_from_id,
                    paymentTermId: freePack?.hslp?.paymentTermId ?? freePack?.hslp?.payment_term_id,
                    price: freePack.hslp.price
                }
            };
        }

    }
    return [];
}
